import { useEffect, useMemo, useRef, useState } from 'react';
import { weekDays } from '../../../../../../../Costants/costants';
import { IBusinessProfile } from '../../../../../../../Interfaces/responseTypes';
import { formatBusinessHours } from '../../../../../../../Utilits/utilits';

export const useBusinessClosedNotice = (profile: IBusinessProfile) => {
  const [expanded, setExpanded] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  const freeDays = useMemo(
    () => weekDays
      .filter((day) => profile.free_days?.includes(+day.id))
      .map((day) => day.title),
    [profile.free_days],
  );

  const dailyHours = profile.is_24 ? null : formatBusinessHours(profile);

  useEffect(() => {
    if (!expanded) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
        setExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [expanded]);

  const toggle = () => setExpanded((prev) => !prev);

  return {
    expanded,
    toggle,
    rootRef,
    freeDays,
    dailyHours,
  };
};
